/* @ngInject */
const entities = (
  $$railway,
  $$area,
  $$contact,
  $$owner,
  $$dispatch,
  $$movement,
  $$train,
  $$wagon,
  $$sale,
  $$axletree,
  $$piece,
  $$sterile,
  $$commande,
  accountMetadata,
  accountRequest
) => {
  const self = {}

  self.railway = $$railway
  self.area = $$area
  self.contact = $$contact
  self.owner = $$owner
  self.dispatch = $$dispatch
  self.movement = $$movement
  self.train = $$train
  self.wagon = $$wagon
  self.sale = $$sale
  self.axletree = $$axletree
  self.piece = $$piece
  self.sterile = $$sterile
  self.commande = $$commande

  self.account = {
    metadata: accountMetadata,
    request: accountRequest,
  }

  return self
}
export default entities



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/entities.service.js